<p class="text-center my-3">Processing your details</p>

<fgbcl-loading></fgbcl-loading>
